




























































import { Vue, Component, Watch } from "vue-property-decorator";
import { UserService } from "src/services";
import { IUserPasswordModel } from "src/model";
import router from '../../router';

@Component
export default class Shop extends Vue
{
     /**
     * labelCol
     * @protected
     * @return any
     */
    protected labelCol: any = {
        xs: { span: 8 },
        sm: { span: 8 },
    };

     /**
     * wrapperCol
     * @protected
     * @return any
     */
    protected wrapperCol: any = {
        xs: { span: 15 },
        sm: { span: 15 },
    };

    /**
     * 表单规则
     * @protected
     */
    protected get rules(): any
    {
        let self: any = this;
        return {
            oldPassword: [{ required: true, message: "请输入旧密码", trigger: "blur" },
                        { min: 6, message: '旧密码长度必须大于6', trigger: 'blur' }],
            password: [{ required: true,  message: "请输入新密码", trigger: "blur" },
                        { min: 6, message: '密码长度必须大于6', trigger: 'blur' }],
             confirm: [
                { required: true,  message: "请输入确认新密码", trigger: "blur" },
                { trigger: "blur", validator: (rule, value, callback)=>{
                        if(value != this.formData.password)
                        {
                            callback("两次输入的密码不一致")
                        }
                        callback()
                    }
                }
            ]
        }
    }

    /**
     * 表单数据
     * @protected
     * @return ICheckupItemModel
     */
    protected formData: IUserPasswordModel = {
        oldPassword: "",
        password: "",
        confirm: ""

    };

    
    /**
     * 获取用户服务
     * @private
     * @return UserService
     */
    private _userService: UserService;

    /**
     * 获取或设置用户服务。
     * @protected
     * @returns UserService
     */
    protected get userService(): UserService
    {
        if(!this._userService)
        {
            this._userService = this.$serviceProvier.resolve<UserService>(UserService);
        }

        return this._userService;
    }

    /**
     * 用户信息
     * @protected
     * @type {any}
     */
    protected get userInfo(): any {

        return this.$store.getters["global/userInfo"]
    }

    /**
     * 组件创建钩子。
     * @protected
     * @returns void
     */
    protected created(): void
    {
        // this.getMyTenants();
    }

    /**
   * 注销登录
   * @protected
   * @return void
   */
  protected async logout(): Promise<void> {
    try {
      await this.userService.logout();
    } catch (err) {
      this.$message.error({
        duration: 3,
        content: err || "服务器错误",
      });
    }
  }
  /**
     * 新增/编辑表单实例。
     * @protected
     * @returns any
     */
    public get $form(): any
    {
        return this.$refs.form as any;
    }
    /**
     * 返回上一页
     * @protected
     */
    protected onCancel(): void
    {
        this.$router.go(-1);
    }
    /**
     * 修改密码
     * @protected
     */
    protected async onSubmit(parameter: any): Promise<any> {
        let _this = this;
        let data = Object.assign({}, this.formData);
        this.$form.validate(async (valid: boolean)=>
        {
            if (valid) {
                try {
                    await this.userService.changePassword(data);
                    this.$message.success("修改成功！");
                    setTimeout(() => {
                        _this.loginOutF();
                    }, 1000);
                } catch (err) {
                    this.$message.error(JSON.stringify(err));
                }
            }
        })
    }


    /**
     * 退出登录
     * @protected
     * @returns void
     */
    protected loginOut(): void
    {
        let _this = this;
        this.$confirm({
            title: "提示",
            content: "是否确定注销登录?",
            okText: "确定",
            cancelText: "取消",
            onOk: () => {
                _this.loginOutF();
            },
            onCancel() {},
         });
    }


    /**
     * 退出登录
     * @protected
     * @returns void
     */
    protected async loginOutF(): Promise<any> 
    {
        return await this.logout()
        .then(() => {
            setTimeout(() => {
                localStorage.clear();
                this.$router.push("/")
            }, 20);
        })
        .catch(() => {
            this.$message.error("注销失败");
        });
    }
     /**
     * 返回首页
     * @protected
     * @returns void
     */
    protected gotoIndex(): void
    {
       this.$router.push({name: 'shop'})
    }
}
